import { AxiosRequestConfig } from 'axios';

import { ProblemAndAnswer } from '../shared';
import { BASE_API } from '../utils';

interface Params {
  skillId: string;
  positionWithinSkill: number;
  refresh: boolean;
  skillDiscovery?: boolean;
  lastUpdated?: number;
}

interface ShowConfig extends AxiosRequestConfig {
  params: Params;
  method: 'GET';
  url: `/exams/${string}/locked-problems`;
}

export interface LockedProblemResponse {
  clientProblem: ProblemAndAnswer;
  canRevert?: boolean;
  outdated?: boolean;
}

/**
 * examIdentifier is either the numeric id of the exam template
 * or a client-side generated unsavedIdentifier string
 */
export const show = (
  examIdentifier: string,
  skillId: string,
  positionWithinSkill: number,
  refresh?: boolean,
  skillDiscovery?: boolean,
  lastUpdated?: number,
): ShowConfig => {
  const params: Params = {
    skillId,
    positionWithinSkill,
    refresh: !!refresh,
  };

  if (skillDiscovery) {
    params.skillDiscovery = true;
    params.lastUpdated = lastUpdated;
  }

  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/exams/${examIdentifier}/locked-problems`,
    params,
  };
};
